// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"InteractiveImportRowCellPlaceholder-placeholder-27Cgm"};